import React, { useContext, useEffect, useState } from "react";

import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

const DetalleIngresosBodega = ({
  listadoDet,
  setIngresoEdit,
  setOrderToShow,
  loading,
  setShowDialog,
  setOrdenDialog,
  selectedDetalle,
  setSelectedDetalle,
  verCostosBodega,
  reg
}) => {
  const { userAuth } = useContext(AuthContext);

  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [verCostos, setVerCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol == 1);


  const columns = [
    {
      // Comment
      field: "IdIngresoDetalle",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdIngresoDetalle,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // Comment
      field: "FechaIngreso",
      header: "Fecha Ingreso",
      headerEn: "Fecha Ingreso",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.FechaIngreso,
      frozen: "frozen",
      className: "small",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "medium",
      frozen: true,
      // cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      // PurchaseRequest
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    reg ?
    {
      field: "TipoIngreso",
      header: "Tipo Ingreso",
      headerEn: "Income Type",
      className: "small",
    } : null,
    {
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Code",
      // frozen: true,
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      // Comment
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      // Comment
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "NombreTipoProducto",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
    },
    {
      // Comment
      field: "Term",
      header: "Término de Compra",
      headerEn: "Purchase Term",
      className: "small",
    },
    {
      // Comment
      field: "Factura",
      header: "Factura",
      headerEn: "Invoice",
      className: "large",
    },
    {
      // Comment
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse Name",
      className: "large",
      body: (rowData) => rowData.NombreBodega,
    },
    {
      // Comment
      field: "NombreEstante",
      header: "Estante",
      headerEn: "Shelf Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreEstante,
    },
    {
      // Comment
      field: "NombrePosicion",
      header: "Fila",
      headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombrePosicion,
    },
    {
      // Comment
      field: "NombreBandeja",
      header: "Bandeja",
      // headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreBandeja,
    },
    {
      // Comment
      field: "PurchaseOrder",
      header: "No. Orden",
      headerEn: "No. Order",
      className: "Xsmall",
      body: (rowData) => rowData.PurchaseOrder,
      Format: "Modal",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },
    {
      // Comment
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
    },
    {
      // Comment
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      body: (rowData) => rowData.Currency,
    },
    {
      header: "Ingresado",
      headerEn: "Type",
      field: "Ingreso",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      Sumary: "sum",
      alignFrozen: "right",
    },
    {
      header: "Ingresado",
      headerEn: "Type",
      field: "CantidadReservada",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      Sumary: "sum",
      alignFrozen: "right",
    },
    {
      // Comment
      field: "NoLote",
      header: "No. Lote",
      headerEn: "No. Lote",
      className: "large",
      body: (rowData) => rowData.NoLote,
    },
    {
      // Comment
      field: "NoLoteInt",
      header: "No. Lote Interno",
      headerEn: "No. Lote Interno",
      hidden: userAuth.IdRol === 1,
      className: "large",
      body: (rowData) => rowData.NoLoteInt,
    },
    {
      // Comment
      field: "NoSacos",
      header: "No. Sacos",
      headerEn: "No. Sacos",
      Format: "Currency",
      // hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      body: (rowData) => rowData.NoSacos,
    },
    {
      // Comment
      field: "FechaObsoleto",
      header: "Fecha Obsoleto",
      headerEn: "Fecha Obsoleto",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.FechaObsoleto,
      // frozen: "frozen",
      className: "small",
    },
    {
      // Comment
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventary",
      Format: "Currency",
      Sumary:"sum",
      className: "Xsmall",
      body: (rowData) => rowData.Inventario,
    },
    {
      header: "Requerido",
      headerEn: "Type",
      field: "Quantity",
      Format: "Currency",
      className: "Xsmall",
      Sumary:"sum",
    },
    {
      // Comment
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Exchange Rate",
      Format: "Decimal",
      // Sumary: "sum",
      className: "Xsmall",
      body: (rowData) => rowData.TasaCambio,
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
    },

    // EMBALAJE
    {
      headerName: 'Embalaje',
      children: [          
        {
          field: "EmbalajeL",
          header: "Monto L",
          Sumary: "sum",
          headerEn: "Monto L",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          Sumary: "sum",
          headerEn: "Amount $",      
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
      ]
    },

    // DESADUANAJE
    {
      headerName: 'Desaduanaje',
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // FLETE
    {
      headerName: 'Flete',
      children: [          
        {
          field: "FleteL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "FleteD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // OTROS COSTOS
    {
      headerName: 'Otros Costos',
      children: [          
        {
          field: "OtrosCostosL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ]
    },

    // LEMPIRAS
    {
      headerName: 'Lempiras',
      header: 'Lempiras',
      children: [
        {
          // Comment
          field: "PrecioL",
          header: "Precio L",
          headerEn: "Price L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "SubTotal",
          header: "SubTotal L",
          headerEn: "SubTotal L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.SubTotal,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISVProductoL",
          header: "ISV L",
          headerEn: "IISV L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "Descuento",
          header: "Desc. L",
          headerEn: "Disc. L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.Descuento,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          header: "MontoL",
          headerEn: "MontoL",
          // onChange: (data) => changePrecio(data),
          field: "MontoL",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
      ]
    },
    //COSTO L 
    {
      // Comment
      field: "CostoL",
      header: "Costo L",
      headerEn: "Costo L",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      body: (rowData) => rowData.MontoL,
      hidden: hiddenPriceColumn,
      frozen: true,
      alignFrozen: "right",
    },


    // DOLARES
    {
      headerName: 'Dolares',
      header: 'Dolares',
      children: [
        {
          // Comment
          field: "PrecioD",
          header: "Precio $",
          headerEn: "Price $",
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "SubTotalD",
          header: "SubTotal $",
          headerEn: "SubTotal $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.SubTotalD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISVProductoD",
          header: "ISV $",
          headerEn: "ISV $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "DescuentoD",
          header: "Desc. %",
          headerEn: "Disc. $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.DescuentoD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          header: "Monto $",
          headerEn: "Amount $",
          // onChange: (data) => changePrecio(data),
          field: "MontoD",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
        // {
        //   // Comment
        //   field: "SubTotalD",
        //   header: "SubTotal D",
        //   headerEn: "SubTotal D",
        //   Format: "Currency",
        //   Sumary: "sum",
        //   className: "Xsmall",
        //   hidden: userAuth.IdRol === 1,
        //   hidden: hiddenPriceColumn,
        // },
        // {
        //   // Comment
        //   field: "DescuentoD",
        //   header: "DescuentoD",
        //   headerEn: "Discount D",
        //   Format: "Currency",
        //   Sumary: "sum",
        //   className: "Xsmall",
        //   hidden: userAuth.IdRol === 1,
        //   hidden: hiddenPriceColumn,
        // },

        // {
        //   // Comment
        //   field: "TAX",
        //   header: "TAX",
        //   headerEn: "TAX",
        //   Format: "Currency",
        //   Sumary: "sum",
        //   className: "Xsmall",
        //   body: (rowData) => rowData.TAX,
        //   hidden: userAuth.IdRol === 1,
        //   hidden: hiddenPriceColumn,
        // },
      ]
    },
    // COSTO D
    {
      // Comment
      field: "CostoD",
      Sumary: "sum",
      header: "Costo $",
      headerEn: "Cost $",
      className: "Xsmall",
      Format: "Currency",
      body: (rowData) => rowData.CostoD,
      hidden: hiddenPriceColumn,
      frozen: true,
      alignFrozen: "right",
    },

    {
      header: "PrecioUL",
      Sumary: "sum",
      headerEn: "PriceUL",
      field: "PrecioUL",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },

    {
      header: "PrecioUD",
      Sumary: "sum",
      headerEn: "PriceUD",
      field: "PrecioUD",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },

  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    fileName: "Ingresos Bodega" + new Date().toDateString(),
    loading: loading,
    clases: "tablaListados",
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
    showModal: (e) => showModal(e),
    key: "IdIngresoDetalle",
  };

  const showModal = (tipoModal) => {
    if (tipoModal === 'ingreso') {
      setShowDialog(true); 
    } else if (tipoModal === 'ordenCompra') {
      setOrdenDialog(true); 
    }
  };

  const Ingreso = (Id) => {
    setIngresoEdit(Id);
    setShowDialog(true);
    // showModal('ingreso'); 
  };
  
  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true)
    showModal('ordenCompra'); 
  };


  return (
    <div style={{ height: "82vh" }}>
      <AgGrid table={table} />
    </div>
  );
};

export default DetalleIngresosBodega;
